import React from 'react';
import { Image } from 'lucide-react';

interface CurrentPosterProps {
  posterName?: string;
  posterImageUrl?: string;
}

const CurrentPoster: React.FC<CurrentPosterProps> = ({ posterName, posterImageUrl }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
        Affiche actuelle
      </h2>
      <div className="aspect-square rounded-lg overflow-hidden bg-gray-100 dark:bg-gray-800">
        {posterImageUrl ? (
          <img
            src={posterImageUrl}
            alt={posterName || 'Affiche'}
            className="w-full h-full object-cover"
            onError={(e) => { (e.currentTarget.style.visibility = 'hidden'); }}
          />
        ) : posterName ? (
          <div className="w-full h-full flex items-center justify-center bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300">
            {posterName}
          </div>
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Image className="h-12 w-12 text-gray-400 dark:text-gray-500" />
          </div>
        )}
      </div>
    </div>
  );
};

export default CurrentPoster;